import Button from '@shared/components/Button/Button';
import { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { APP_ROUTES } from 'routes/routePaths';
import testingConstants from 'utils/testingConstants';

const JoinAgainButton = ({ children }: PropsWithChildren) => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const lastIndex = pathname.lastIndexOf('/');
  const goBackRoute = pathname.substring(0, lastIndex) + search;

  const handleJoinAgainClick = () => navigate(goBackRoute);

  return (
    <Button variant="primary" onClick={handleJoinAgainClick} data-testid={testingConstants.endCallPopupCloseBtn}>
      {children}
    </Button>
  );
};

const BackToMainPageButton = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  // The RoomEndedPage is only reached for non-messenger meetings — `useHangup`
  // routes messenger calls straight back to their chat. Return the user to
  // the meetings page so the meeting context is preserved, regardless of their
  // layout preference (mirrors the messenger-call → back-to-chat behavior).
  const handleBackToMainPageClick = () => navigate(APP_ROUTES.meetings);

  return (
    <Button
      variant="contrastTertiary"
      onClick={handleBackToMainPageClick}
      data-testid={testingConstants.backToMainPageButton}
    >
      {t('back_to_main_page')}
    </Button>
  );
};

const ButtonsBlock = ({ children }: PropsWithChildren) => <div className="flex flex-col space-y-4">{children}</div>;

ButtonsBlock.JoinAgainButton = JoinAgainButton;
ButtonsBlock.BackToMainPageButton = BackToMainPageButton;

export default ButtonsBlock;
